<template lang="pug">
.line
  label {{ label }}
  .range(:style="{ left: `${ percent(0) }%`, right: `${ 100 - percent(1) }%` }")
</template>
<script>
export default {
  name: 'quantile',
  props: {
    max: {
      type: Number,
      default: 5
    },
    label: String,
    value: Array
  },
  methods: {
    percent(index) {
      const { value, max } = this;
      return value[index] / max * 100
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.line {
  position: relative;
  width: 100%;
  height: 0.7rem;
  border: 1px solid $brn;
  //border-top-width: 0;
  border-radius: 3px;
  // border-bottom-left-radius: 3px;
  // border-bottom-right-radius: 3px;
  label {
    position: absolute;
    left: 50%;
    top: 0;
    width: 92%;
    transform: translate3d(-50%, -50%, 0);
    background-color: white;
    z-index: 1;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border: 1px solid $brn;
  }
  .range {
    position: absolute;
    top: 0;
    height: 100%;
    background-color: $brn;
  }
}
</style>
